import {
  List,
  Datagrid,
  ChipField,
  TextField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  RichTextField,
  Create,
  SelectInput,
  Show,
  SimpleShowLayout,
  BooleanField,
  BooleanInput,
  ReferenceField,
  ImageInput,
  ImageField,
  DateField,
  required,
} from 'react-admin'

import { CustomRichTextInput } from '../components/CustomRichTextInput'

import {
  USER_TYPE_OPTIONS,
  PHASE_TYPE_OPTIONS,
  RECCOMENDATION_TYPE_OPTIONS,
} from '../config/constants'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

const validateShortRecommendation = (value, allValues) => {
  if (allValues.recommendationType === 'fasting') {
    const timePattern = /^\d{1,2}:\d{1,2}$/
    if (!timePattern.test(value)) {
      return 'Must be in format like 16:8'
    }
  }
  return undefined
}

export const StaticRecommendationList = ({ isEdit, isDelete }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <ChipField source="userType" />
      <ChipField source="phaseType" />
      <ChipField source="recommendationType" />
      <BooleanField source="isOverweight" />
      <TextField source="shortRecommendation" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
      {isDelete && <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />}
    </Datagrid>
  </List>
)

export const StaticRecommendationEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput
        source="shortRecommendation"
        fullWidth
        multiline
        validate={validateShortRecommendation}
      />
      <CustomRichTextInput size="medium" source="detailedRecommendation" fullWidth />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
)

export const StaticRecommendationCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput source="userType" choices={USER_TYPE_OPTIONS} validate={required()} />
      <SelectInput source="phaseType" choices={PHASE_TYPE_OPTIONS} validate={required()} />
      <SelectInput
        source="recommendationType"
        choices={RECCOMENDATION_TYPE_OPTIONS}
        validate={required()}
      />
      <BooleanInput source="isOverweight" label="Is Overweight" validate={required()} />
      <TextInput
        source="shortRecommendation"
        fullWidth
        multiline
        validate={validateShortRecommendation}
      />
      <CustomRichTextInput
        size="medium"
        source="detailedRecommendation"
        fullWidth
        validate={required()}
      />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
)

export const StaticRecommendationShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="userType" />
      <ChipField source="phaseType" />
      <ChipField source="recommendationType" />
      <BooleanField source="isOverweight" />
      <TextField source="shortRecommendation" />
      <RichTextField source="detailedRecommendation" />
      <ImageField source="imageUrl" label="Image" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
